module.exports = __webpack_public_path__ + "img/picture_kydyb.0e209eb1.png";